import { useState } from 'react';
import { User, GamePassConfig } from '../types';

export const useAuth = (config: Partial<GamePassConfig> = {}) => {
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const signOut = () => {
    setUser(null);
    setIsAuthenticated(false);
  };

  const handleSuccess = (userData: User) => {
    setUser(userData);
    setIsAuthenticated(true);
    config.onSuccess?.(userData);
  };

  return {
    user,
    isAuthenticated,
    signOut,
    handleSuccess,
  };
};